import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { parseRmaDetailDTO, RmaDetailDTO } from 'components/ordering/rma/api/dtos/rma-detail-dto.js'

export class GetRmaDetail extends RmaRequest<RmaDetailDTO, never> {
  path: string

  constructor(rmaId: string) {
    super()
    this.path = `account/rma/detail/${encodeURIComponent(rmaId)}/fetch/`
  }

  override parseResponse = (data: unknown) =>
    parseRmaDetailDTO((data as { results: unknown }).results)
}
